import * as Yup from 'yup';

export const instructionsSchema = Yup.object({
  desktop: Yup.string().required('required').min(1, 'so short'),
  mobile: Yup.string().notRequired().min(1, 'so short'),
});
